"use strict";
exports.__esModule = true;
exports.chart_threshold_stroke_Width = {
  "name": "--pf-chart-threshold--stroke--Width",
  "value": 1.5,
  "var": "var(--pf-chart-threshold--stroke--Width, 1.5)"
};
exports["default"] = exports.chart_threshold_stroke_Width;